import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoImpactoOrcamentario } from '../../../models/projeto-impacto-orcamentario.model';
import { ProjetoImpactoOrcamentarioService } from '../../../services/projeto-impacto-orcamentario.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationService } from 'src/app/modules/projeto-completo/services/navigation.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../../models/atualizacoes-audit.model';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';

@Component({
  selector: 'app-impacto-orcamentario-edit',
  templateUrl: './impacto-orcamentario-edit.component.html',
  styleUrls: ['./impacto-orcamentario-edit.component.scss'],
})
export class ImpactoOrcamentarioEditComponent
  extends BaseFormComponent<ProjetoImpactoOrcamentario>
  implements OnInit
{
  actionLabel: string = 'Novo';
  idProjeto: any;
  canSave: boolean = false;
  canEdit: boolean = false;
  audit: AtualizacoesAudit;

  constructor(
    private myService: ProjetoImpactoOrcamentarioService,
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService,
    public maskService: MaskService,
    private router: Router
  ) {
    super(activatedRoute);
  }

  ngOnInit(): void {
    this.loaded();

    if (this.entity) {
      this.idProjeto = this.entity.pp_id;
      this.canSave = this.entity.canSave;
      this.canEdit = this.entity.canEdit;
    } else {
      let currentUrl = this.router.url;
      const regex = /projeto\/(\d+)\/custos/;
      const match = currentUrl.match(regex);

      if (match) {
        this.idProjeto = match[1];
      } else {
        console.log('ID não encontrado');
      }

      this.canSave = true;
      this.canEdit = true;
    }
    this.initForm();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [
        Validators.required,
        Validators.maxLength(300),
      ]),
      year_1: new FormControl('', Validators.maxLength(300)),
      year_2: new FormControl('', Validators.maxLength(300)),
      year_3: new FormControl('', Validators.maxLength(300)),
      ds_method: new FormControl('', Validators.maxLength(3000)),
      pp_id: new FormControl(''),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);

      if (!this.canEdit) {
        this.form.disable();
      }
      this.audit = {
        cost_impact_id: this.entity.id,
      };
    }
  }

  maskCurrency(event, field) {
    let value = this.maskService.formatarMedidaFisica(
      event.target?.value,
      2,
      10
    );
    this.form.get(field).setValue(value);
  }

  voltar() {
    this.navigation.back(['pre-projeto/projeto/' + this.idProjeto + '/custos']);
  }

  getDataCreate(): ProjetoImpactoOrcamentario {
    let data: ProjetoImpactoOrcamentario;
    data = Object.assign({}, data, this.form.value);
    data.pp_id = this.idProjeto;
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService
            .update(this.getDataCreate(), this.entity?.id)
            .subscribe({
              next: (res: ProjetoImpactoOrcamentario) => {
                this.msgSuccess('Cadastro alterado com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error.message);
                this.loaded();
              },
            })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res: ProjetoImpactoOrcamentario) => {
              this.msgSuccess('Cadastro criado com sucesso!');
              this.navigation.replace([
                'pre-projeto/projeto/custos/impacto',
                res.id,
              ]);
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error.message);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace([
            'pre-projeto/projeto/' + this.idProjeto + '/custos',
          ]);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}
